import { render, staticRenderFns } from "./pension_calculator.vue?vue&type=template&id=7d17c5c5&scoped=true"
import script from "./pension_calculator.vue?vue&type=script&lang=js"
export * from "./pension_calculator.vue?vue&type=script&lang=js"
import style0 from "./pension_calculator.vue?vue&type=style&index=0&id=7d17c5c5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d17c5c5",
  null
  
)

export default component.exports